import React, { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductList from '../components/ProductList';
import { trackMetaEvent } from '../components/MetaPixel';
import styles from '../styles/DealLanding.module.css';

const DealSearch = () => {
    const [searchParams] = useSearchParams();
    const query = useMemo(() => searchParams.get('q') || '', [searchParams]);

    useEffect(() => {
        const description = query
            ? `Busca gangas, descuentos y ofertas de ${query} en Esganga.`
            : 'Busca gangas, descuentos y ofertas por producto, marca, tienda o categoria en Esganga.';
        const metaDescription = document.querySelector('meta[name="description"]');

        document.title = query ? `Buscar ${query} | Gangas y ofertas en Esganga` : 'Buscar gangas y ofertas | Esganga';
        if (metaDescription) {
            metaDescription.setAttribute('content', description);
        }

        if (query) {
            trackMetaEvent('Search', { search_string: query });
        }
    }, [query]);

    return (
        <main className={styles.page}>
            <section className={styles.hero}>
                <p className={styles.kicker}>Buscador</p>
                <h1>{query ? `Gangas para "${query}"` : 'Buscar ofertas en Esganga'}</h1>
                <p>
                    Escribe un producto, marca o tienda y ordena los resultados por descuento, precio o novedades.
                </p>
            </section>

            <ProductList
                initialSearch={query}
                eyebrow="Busqueda inteligente"
                title="Resultados faciles de comparar"
                description="Mira primero lo importante: precio, descuento, tienda y detalles antes de abrir la oferta."
                initialSort="relevance"
            />
        </main>
    );
};

export default DealSearch;
